// Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

// Auth
export const SIGNIN = '/';

export const EXPIRATIONTOKEN = '/expirationtoken';

export const PAGENOTFOUND = '/*';

// Home
export const HOME = '/home';

// Users
export const USERS = '/users';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

// Assistant
export const ASSISTANT = '/assistant';
export const SHAREPOINT_AUTH = '/sharepoint-auth';
export const SHAREPOINT_REDIRECT = '/sharepoint';

// Chat assistant
export const CHAT_ASSISTANTS = '/chat-assistant';
export const CHAT_ASSISTANT_NEW = `${CHAT_ASSISTANTS}/new`;
export const CHAT_ASSISTANT_EDIT = `${CHAT_ASSISTANTS}/edit`;
//Licitaciones
export const LICITACIONES = '/licitaciones';
export const LICITACIONES_NEW = `${LICITACIONES}/new`;
export const LICITACIONES_EDIT = `${LICITACIONES}/edit`;
